import styled from 'styled-components';

import { BREAKPOINTS } from "../../../../app/appConstants";

export const ZendeskButtonStyled = styled.button`
    border: none;
    padding: 0;
    background: none;
    display: flex;
    align-items: center;
    svg {
        fill: var(--icon-primary-color);
    }
    &:hover:not(:disabled) {
        svg {
            fill: var(--color-white);
        }
    }
`;

export const ZendeskFixedButtonStyled = styled(ZendeskButtonStyled)`
    position: fixed;
    bottom: 16px;
    right: 48px;
    padding: 12px;
    background: var(--color-purple);
    border-radius: 4px;
    z-index: 10;
    box-shadow: 0 0 25px rgba(0, 0, 0, 0.25);
    &:hover:not(:disabled) {
        background: var(--color-purple-highlight);
    }
    @media (max-width: ${BREAKPOINTS.small}px) {
        bottom: 8px;
        right: 8px;
    }
`;
